import saveAs, { type TypeSaveAsConfig } from './saveAs';

// ----------------------------------------------------------------------------

export type TypeSaveToBlobConfig = TypeSaveAsConfig & {
    mimeType?: string;
};

// ----------------------------------------------------------------------------

function saveToBlob(content: string, config: TypeSaveToBlobConfig = {}): void {
    const resolvedConfig: TypeSaveToBlobConfig = {
        mimeType: 'application/octet-stream',
        ...config,
    };

    // ------------------------------------------------------------------------

    const blob = new Blob([content], {
        type: resolvedConfig.mimeType,
    });

    saveAs(blob, resolvedConfig);
}

// ----------------------------------------------------------------------------

export default saveToBlob;
